module.exports = __webpack_public_path__ + "img/Trivium_white.665f07fb.svg";